module.exports = __webpack_public_path__ + "media/1893-1975.bc144875.mp4";